module.exports = __webpack_public_path__ + "img/Group_9.99aaad64.png";